module.exports = __webpack_public_path__ + "static/media/3.98d1264e.png";